module.exports = __webpack_public_path__ + "static/img/微信号.75448d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/微信号.png
// module id = xGtU
// module chunks = 11